export const de: Record<string, string> = {
  'app.save': 'Speichern',
  'app.logout': 'Abmelden',
  'user.change_password': 'Passwort ändern',
  'user.password': 'Passwort',
  'user.repeat_password': 'Passwort wiederholen',
  'user.email': 'E-Mail',
  'user.name': 'Name',
  'user.language': 'Sprache'
};
